/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  PasswordInput,
  PasswordRequestInput,
  StandardError,
  StandardMessage,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Update password
 */
export const updatePassword = (
    passwordInput: MaybeRefOrGetter<PasswordInput>,
 signal?: AbortSignal
) => {
      passwordInput = toValue(passwordInput);

      return axiosClient<StandardMessage>(
      {url: `/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: passwordInput, signal
    },
      );
    }




export const getUpdatePasswordMutationKey = () => ['updatePassword'] as const;

export const getUpdatePasswordMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,UpdatePasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,UpdatePasswordMutationVariables, TContext> => {

const mutationKey = getUpdatePasswordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePassword>>, UpdatePasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof updatePassword>>>
    export type UpdatePasswordMutationBody = PasswordInput
    export type UpdatePasswordMutationError = ErrorType<ValidationError | StandardError>
    export type UpdatePasswordMutationVariables = {data: PasswordInput}

    /**
 * @summary Update password
 */
export const useUpdatePassword = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePassword>>, TError,UpdatePasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePassword>>,
        TError,
        UpdatePasswordMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Request Password reset
 */
export const requestPasswordReset = (
    passwordRequestInput: MaybeRefOrGetter<PasswordRequestInput>,
 signal?: AbortSignal
) => {
      passwordRequestInput = toValue(passwordRequestInput);

      return axiosClient<StandardMessage>(
      {url: `/password/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordRequestInput, signal
    },
      );
    }




export const getRequestPasswordResetMutationKey = () => ['requestPasswordReset'] as const;

export const getRequestPasswordResetMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext> => {

const mutationKey = getRequestPasswordResetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPasswordReset>>, RequestPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestPasswordReset(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof requestPasswordReset>>>
    export type RequestPasswordResetMutationBody = PasswordRequestInput
    export type RequestPasswordResetMutationError = ErrorType<ValidationError>
    export type RequestPasswordResetMutationVariables = {data: PasswordRequestInput}

    /**
 * @summary Request Password reset
 */
export const useRequestPasswordReset = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof requestPasswordReset>>,
        TError,
        RequestPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getRequestPasswordResetMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Password with Token
 */
export const updatePasswordWithToken = (
    token: MaybeRefOrGetter<string>,
    passwordInput: MaybeRefOrGetter<PasswordInput>,
 signal?: AbortSignal
) => {
      token = toValue(token);
passwordInput = toValue(passwordInput);

      return axiosClient<StandardMessage>(
      {url: `/password/${token}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: passwordInput, signal
    },
      );
    }




export const getUpdatePasswordWithTokenMutationKey = () => ['updatePasswordWithToken'] as const;

export const getUpdatePasswordWithTokenMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePasswordWithToken>>, TError,UpdatePasswordWithTokenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePasswordWithToken>>, TError,UpdatePasswordWithTokenMutationVariables, TContext> => {

const mutationKey = getUpdatePasswordWithTokenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePasswordWithToken>>, UpdatePasswordWithTokenMutationVariables> = (props) => {
          const {token,data} = props ?? {};

          return  updatePasswordWithToken(token,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePasswordWithTokenMutationResult = NonNullable<Awaited<ReturnType<typeof updatePasswordWithToken>>>
    export type UpdatePasswordWithTokenMutationBody = PasswordInput
    export type UpdatePasswordWithTokenMutationError = ErrorType<ValidationError>
    export type UpdatePasswordWithTokenMutationVariables = {token: string;data: PasswordInput}

    /**
 * @summary Update Password with Token
 */
export const useUpdatePasswordWithToken = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePasswordWithToken>>, TError,UpdatePasswordWithTokenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePasswordWithToken>>,
        TError,
        UpdatePasswordWithTokenMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePasswordWithTokenMutationOptions(options), queryClient);
    }
